module.exports = __webpack_public_path__ + "img/fd-zh-002.6629c806.png";